<template>
  <div class="dashboard">
    <AlbumListContainer />
    <loader :loading-promise="albumsPromise">
      <div class="gimme-some-space">
        <albums-wall :albums="albums" :pages="pages" />
      </div>
    </loader>
  </div>
</template>

<script>
import axios from 'axios'
import AlbumListContainer from './AlbumListContainer'
import AlbumsWall from './AlbumsWall'
import Loader from './Loader'
export default {
  data() {
    return {
      albumsPromise: null,
      albums: null,
      pages: null,
    }
  },
  mounted() {
    this.albumsPromise = axios.get('/api/albums').then(response => {
      this.albums = response.data.albums
      this.pages = response.data.pages
    })
  },
  components: {
    AlbumListContainer,
    AlbumsWall,
    Loader,
  },
}
</script>

<style lang="stylus" scoped>
.dashboard
  display flex
  padding 0 30px

.gimme-some-space
  padding 30px
</style>
